import { useState } from 'react';
import { IconButton, IconContainer } from '@epam/promo';
import { ReactComponent as CrossIcon } from '@epam/assets/icons/common/navigation-close-24.svg';
import { ReactComponent as WarningIcon } from '@epam/assets/icons/common/notification-warning-fill-24.svg';
import css from './NoInternetConnection.module.scss';

export const NoInternetConnection = () => {
  const [isShown, setIsShown] = useState(true);

  if (!isShown) return null;

  return (
    <div className={css.container}>
      <p>
        <IconContainer
          icon={WarningIcon}
          style={{ fill: 'var(--uui-warning-50)' }}
        />
        <span>
          Make sure you are connected to the internet and your connection to
          Admin Panel is not blocked by a firewall or proxy.
        </span>
      </p>
      <IconButton icon={CrossIcon} onClick={() => setIsShown(false)} />
    </div>
  );
};
